import React from "react";
import useApiEp from "../../hooks/useApiEp";
import { Box, Skeleton, Alert } from "@mui/material";

const TemplateMessage = ({ id, to }) => {
  const { data, isLoading, isError } = useApiEp(
    `/message/get-template-message/${id}?to=${to}`
  );

  if (isLoading) return <TemplateSkeleton />;

  if (isError || !data?.message) {
    return (
      <Alert
        severity="warning"
        sx={{ py: 0, px: 1, fontSize: "0.75rem", borderRadius: 2 }}
      >
        Could not load template
      </Alert>
    );
  }

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: data.message }}
      sx={{
        "& > div": {
          maxWidth: "100% !important",
        },
      }}
    />
  );
};

const TemplateSkeleton = () => (
  <Box sx={{ width: 220, display: "flex", flexDirection: "column", gap: 0.8 }}>
    <Skeleton variant="text" width="60%" height={18} sx={{ borderRadius: 1 }} />
    <Skeleton
      variant="text"
      width="100%"
      height={14}
      sx={{ borderRadius: 1 }}
    />
    <Skeleton variant="text" width="90%" height={14} sx={{ borderRadius: 1 }} />
    <Skeleton variant="text" width="75%" height={14} sx={{ borderRadius: 1 }} />
    <Skeleton
      variant="text"
      width="40%"
      height={12}
      sx={{ borderRadius: 1, mt: 0.5, alignSelf: "flex-end" }}
    />
  </Box>
);

export default TemplateMessage;
